import React from 'react'
import InsightsDashboardPool from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'

export type DuckActionPayloadTuple<T = void> = T extends void ? [string, string] : [string, string, T]
export type PoolDispatchSignatureType = <T = void>(args: DuckActionPayloadTuple<T>) => void

export const poolDispatch: PoolDispatchSignatureType = <T>(duckActionPayloadTuple: DuckActionPayloadTuple<T>) => {
  InsightsDashboardPool.dispatch(
    ...(duckActionPayloadTuple as unknown as Parameters<typeof InsightsDashboardPool.dispatch>)
  )
}
